import {
  InputField,
  InputNumber,
  SelectFieldForId,
} from "components/Common/input-fields"
import Notify from "components/Common/notify"
import { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import {
  PaymentCreate,
  PaymentUpdate,
} from "redux/slice/payment/paymentSlice"
import {
  allScholarships,
  ScholarshipFetch,
} from "redux/slice/scholarship/scholarshipSlice"
import {
  IS_PAID_OPTIONS,
  PAYMENT_MODE_OPTIONS,
  MONTH_OPTIONS,
  YEAR_OPTIONS,
} from "common/data/paymentOptions"
import { userData } from "redux/slice/user/userSlice"
import { SHUK_ROLE_VIWEWER } from "redux/enums"

export default function PaymentForm(props) {
  const dispatch = useDispatch()
  const { scholarshipData } = useSelector(allScholarships)
  const { userRole } = useSelector(userData)
  const isViewer = userRole === SHUK_ROLE_VIWEWER
  const [editMode, setEditMode] = useState(false)
  const [createData, setCreateData] = useState({
    scholarshipFinanceDataId: "",
    currentYear: "",
    currentSemester: "",
    isPaid: false,
    amountPaid: "",
    paymentModeEnum: "",
    firstPaymentDueDate: "",
    paymentMadeDate: "",
    year: "",
    month: "",
    challanNumber: "",
  })

  const isView = !!props?.view && !editMode
  const isUpdate =
    props?.paymentData && Object.keys(props?.paymentData).length !== 0

  useEffect(() => {
    if (isUpdate) {
      setCreateData(props?.paymentData)
    }
    // populate the scholarship dropdown
    if (!scholarshipData || scholarshipData.length === 0) {
      dispatch(ScholarshipFetch({ pageNumber: 1, pageSize: 500 }))
    }
  }, [])

  const scholarshipOptions = (scholarshipData || []).map(s => ({
    id: s.id,
    name: `${s.paymentId ? s.paymentId + " - " : ""}${s.studentName || ""}`,
  }))

  const handleChangeInfo = (fieldName, value) => {
    if (fieldName === "isPaid") {
      setCreateData(prevState => ({
        ...prevState,
        [fieldName]: value === "true" ? true : false,
      }))
    } else {
      setCreateData(prevState => ({
        ...prevState,
        [fieldName]: value,
      }))
    }
  }

  const handleSubmit = () => {
    if (
      !createData.scholarshipFinanceDataId ||
      !createData.currentYear ||
      !createData.currentSemester ||
      !createData.firstPaymentDueDate ||
      createData.paymentModeEnum === "" ||
      createData.paymentModeEnum === null ||
      createData.paymentModeEnum === undefined ||
      !createData.amountPaid ||
      !createData.paymentMadeDate ||
      !createData.year ||
      !createData.month ||
      !createData.challanNumber
    ) {
      Notify("error", "Fill all the required fields.")
      return
    }

    // PAYMENT_MODE_OPTIONS currently use string values, so send as-is.
    const paymentMode =
      createData.paymentModeEnum === "" ||
      createData.paymentModeEnum === null ||
      createData.paymentModeEnum === undefined
        ? null
        : createData.paymentModeEnum

    const payload = {
      ...createData,
      isPaid: !!createData.isPaid,
      currentYear: createData.currentYear || null,
      currentSemester: createData.currentSemester || null,
      amountPaid: createData.amountPaid || null,
      paymentModeEnum: paymentMode,
      firstPaymentDueDate: createData.firstPaymentDueDate
        ? new Date(createData.firstPaymentDueDate).toISOString()
        : null,
      paymentMadeDate: createData.paymentMadeDate
        ? new Date(createData.paymentMadeDate).toISOString()
        : null,
      year: createData.year || null,
      month: createData.month || null,
      challanNumber: createData.challanNumber || null,
    }

    if (isUpdate) {
      dispatch(PaymentUpdate({ id: props.updateId, data: payload }))
        .then(resp => {
          if (resp?.payload?.status === 200) {
            Notify("success", "Payment Updated")
            props.toggleTab()
          }
        })
        .catch(err => {
          console.log("error", err)
        })
    } else {
      dispatch(PaymentCreate(payload))
        .then(resp => {
          if (
            resp?.payload?.status === 201 ||
            resp?.payload?.status === 200
          ) {
            Notify("success", "Payment Created")
            props.toggleTab()
          }
        })
        .catch(err => {
          console.log("error", err)
        })
    }
  }

  return (
    <div className="card p-2">
      <div className="card-title fs-3 mt-2 mx-4">
        {isView ? "View Payment" : isUpdate ? "Update Payment" : "Create Payment"}
      </div>
      <div className="card-body">
        <div className="row">
          <SelectFieldForId
            label="Scholarship"
            className="col-sm-12 col-md-6 col-lg-4 my-2"
            compulsory={true}
            disabled={isView}
            readOnly={isUpdate}
            selectOptions={scholarshipOptions}
            value={createData.scholarshipFinanceDataId}
            onChange={e =>
              handleChangeInfo("scholarshipFinanceDataId", e.target.value)
            }
          />
          <InputField
            label="Current Year"
            placeholder="Enter Current Year"
            className="col-sm-12 col-md-6 col-lg-4 my-2"
            compulsory={true}
            disabled={isView}
            readOnly={isUpdate}
            type="text"
            value={createData.currentYear}
            onChange={e => handleChangeInfo("currentYear", e.target.value)}
          />
          <InputField
            label="Current Semester"
            placeholder="Enter Current Semester"
            className="col-sm-12 col-md-6 col-lg-4 my-2"
            compulsory={true}
            disabled={isView}
            readOnly={isUpdate}
            type="text"
            value={createData.currentSemester}
            onChange={e => handleChangeInfo("currentSemester", e.target.value)}
          />
          <InputField
            label="Payment Due Date"
            placeholder="Select Payment Due Date"
            className="col-sm-12 col-md-6 col-lg-4 my-2"
            compulsory={true}
            disabled={isView}
            // readOnly={isUpdate}
            type="date"
            value={createData.firstPaymentDueDate}
            onChange={e =>
              handleChangeInfo("firstPaymentDueDate", e.target.value)
            }
          />
          <SelectFieldForId
            label="Is Paid"
            className="col-sm-12 col-md-6 col-lg-4 my-2"
            compulsory={true}
            disabled={isView}
            selectOptions={IS_PAID_OPTIONS}
            value={createData.isPaid}
            onChange={e => handleChangeInfo("isPaid", e.target.value)}
          />
          <InputNumber
            label="Amount Paid"
            placeholder="Enter Amount Paid"
            className="col-sm-12 col-md-6 col-lg-4 my-2"
            compulsory={true}
            disabled={isView}
            type="number"
            min={0}
            value={createData.amountPaid}
            onChange={e => handleChangeInfo("amountPaid", e.target.value)}
          />
          <SelectFieldForId
            label="Payment Mode"
            className="col-sm-12 col-md-6 col-lg-4 my-2"
            compulsory={true}
            disabled={isView}
            selectOptions={PAYMENT_MODE_OPTIONS}
            value={createData.paymentModeEnum}
            onChange={e => handleChangeInfo("paymentModeEnum", e.target.value)}
          />
          <InputField
            label="Payment Made Date"
            placeholder="Select Payment Made Date"
            className="col-sm-12 col-md-6 col-lg-4 my-2"
            compulsory={true}
            disabled={isView}
            type="date"
            value={createData.paymentMadeDate}
            onChange={e => handleChangeInfo("paymentMadeDate", e.target.value)}
          />
          <SelectFieldForId
            label="Year"
            className="col-sm-12 col-md-6 col-lg-4 my-2"
            compulsory={true}
            disabled={isView}
            selectOptions={YEAR_OPTIONS}
            value={createData.year}
            onChange={e => handleChangeInfo("year", e.target.value)}
          />
          <SelectFieldForId
            label="Month"
            className="col-sm-12 col-md-6 col-lg-4 my-2"
            compulsory={true}
            disabled={isView}
            selectOptions={MONTH_OPTIONS}
            value={createData.month}
            onChange={e => handleChangeInfo("month", e.target.value)}
          />
          <InputField
            label="Challan Number"
            placeholder="Enter Challan Number"
            className="col-sm-12 col-md-6 col-lg-4 my-2"
            compulsory={true}
            disabled={isView}
            type="text"
            value={createData.challanNumber}
            onChange={e => handleChangeInfo("challanNumber", e.target.value)}
          />
        </div>
        <div className="d-flex justify-content-end mt-4">
          {isView ? (
            <>
              {!isViewer && (
                <button
                  className="btn btn-success me-2"
                  onClick={() => setEditMode(true)}
                >
                  Edit
                </button>
              )}
              <button
                className="btn btn-primary"
                onClick={() => props.toggleTab()}
              >
                Back
              </button>
            </>
          ) : (
            <>
              <button
                className="btn btn-danger me-2"
                onClick={() => props.toggleTab()}
              >
                Cancel
              </button>
              <button className="btn btn-primary" onClick={handleSubmit}>
                {isUpdate ? "Update" : "Create"}
              </button>
            </>
          )}
        </div>
      </div>
    </div>
  )
}
